/**
 * Delivery Estimation
 * Calculates ship date based on cutoff hour + business days, then delivery window.
 * All dates use Europe/Paris timezone.
 */
(function () {
  'use strict';

  var containers = document.querySelectorAll('.delivery-estimation');
  if (!containers.length) return;

  containers.forEach(function (container) {
    var cutoff = parseInt(container.dataset.cutoff, 10);
    var shipsSaturday = container.dataset.shipsSaturday === 'true';
    var daysMin = parseInt(container.dataset.daysMin, 10);
    var daysMax = parseInt(container.dataset.daysMax, 10);
    var isClosed = container.dataset.closed === 'true';
    var badgeText = container.dataset.badgeText || '';
    var headerText = container.dataset.headerText || 'Livraison estimée [date_min] et le [date_max]';

    if (isClosed) {
      container.style.display = 'none';
      return;
    }

    function nowParis() {
      var now = new Date();
      var parisStr = now.toLocaleString('fr-FR', { timeZone: 'Europe/Paris' });
      var parts = parisStr.split(' ');
      var dateParts = parts[0].split('/');
      var timeParts = parts[1].split(':');
      var parisDate = new Date(
        parseInt(dateParts[2], 10),
        parseInt(dateParts[1], 10) - 1,
        parseInt(dateParts[0], 10)
      );
      return {
        date: parisDate,
        hour: parseInt(timeParts[0], 10),
        day: parisDate.getDay()
      };
    }

    function isBusinessDay(dayOfWeek) {
      if (dayOfWeek === 0) return false;
      if (dayOfWeek === 6) return shipsSaturday;
      return true;
    }

    function nextBusinessDay(date) {
      var d = new Date(date);
      do {
        d.setDate(d.getDate() + 1);
      } while (!isBusinessDay(d.getDay()));
      return d;
    }

    function addDays(date, n) {
      var d = new Date(date);
      d.setDate(d.getDate() + n);
      return d;
    }

    function formatShort(date) {
      var dd = String(date.getDate()).padStart(2, '0');
      var mm = String(date.getMonth() + 1).padStart(2, '0');
      return dd + '/' + mm;
    }

    function formatMonthDay(date) {
      var months = [
        'jan.', 'fév.', 'mars', 'avr.', 'mai', 'juin',
        'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'
      ];
      return months[date.getMonth()] + ' ' + date.getDate();
    }

    var paris = nowParis();
    var today = paris.date;
    var shipDate;

    if (paris.hour < cutoff && isBusinessDay(paris.day)) {
      shipDate = today;
    } else {
      shipDate = nextBusinessDay(today);
    }

    var deliveryMin = addDays(shipDate, daysMin);
    var deliveryMax = addDays(shipDate, daysMax);

    // Build header text with replacements
    var headerEl = container.querySelector('[data-delivery-header]');
    if (headerEl) {
      var headerHtml = headerText
        .replace('[date_min]', '<strong>' + formatShort(deliveryMin) + '</strong>')
        .replace('[date_max]', '<strong>' + formatShort(deliveryMax) + '</strong>');

      if (badgeText) {
        headerHtml += ' — ' + badgeText;
      }
      headerEl.innerHTML = headerHtml;
    }

    var orderDateEl = container.querySelector('[data-delivery-order-date]');
    var shipDateEl = container.querySelector('[data-delivery-ship-date]');
    var arriveDateEl = container.querySelector('[data-delivery-arrive-date]');

    if (orderDateEl) orderDateEl.textContent = formatMonthDay(today);
    if (shipDateEl) shipDateEl.textContent = formatMonthDay(shipDate);

    if (arriveDateEl) {
      if (daysMin === daysMax) {
        arriveDateEl.textContent = formatMonthDay(deliveryMin);
      } else {
        arriveDateEl.textContent = formatMonthDay(deliveryMin) + ' - ' + deliveryMax.getDate();
      }
    }
  });
})();
